"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
export function SortableItem({ item, renderItem, disabled = false, }) {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging, } = useSortable({
        id: item.id,
        disabled,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    const dragHandleProps = {
        attributes,
        listeners,
        setActivatorNodeRef,
        isDragging,
        disabled,
    };
    return (_jsx("div", { ref: setNodeRef, style: style, children: renderItem(item, dragHandleProps) }));
}
export default SortableItem;
//# sourceMappingURL=SortableItem.js.map